import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--gray200);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0rem;
    margin-bottom: 0rem;
  }

  span {
    flex: 1;
  }
`

export const Communication = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const CommunicationIconAndNameContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 8px;
`

export const MeansOfCommunicationBrContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 1.5rem;
`

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 2.375rem;
  height: 1.5rem;
  padding: 2px;
`
